// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#errorDiv:hover {
  cursor: pointer !important;
}

.spread-container--results {
  min-height: calc(100% - 50px) !important;
  height: calc(100% - 50px) !important;
}

.close-window-button {
  margin-left: 8px;
  background-color: whitesmoke;
}

.button-section {
  margin: 2px;
  margin-top: 10px;
  height: 30px;
}

kendo-window {
  border: 1px solid #275cab;
  border-radius: 4px !important;
}

:host ::ng-deep kendo-window-titlebar,
:host ::ng-deep .k-dialog-titlebar,
:host ::ng-deep .k-window-titlebar {
  background-color: #51738b !important;
  padding: 0.25rem 0.5rem !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background: rgba(0, 0, 0, 0.6);
}`, "",{"version":3,"sources":["webpack://./src/app/components/results/results.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AAEA;EACE,wCAAA;EACA,oCAAA;AACF;;AAEA;EACE,gBAAA;EACA,4BAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,6BAAA;AACF;;AAEA;;;EAGE,oCAAA;EACA,kCAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;AACF","sourcesContent":["#errorDiv:hover {\r\n  cursor: pointer !important;\r\n}\r\n\r\n.spread-container--results {\r\n  min-height: calc(100% - 50px) !important;\r\n  height: calc(100% - 50px) !important;\r\n}\r\n\r\n.close-window-button {\r\n  margin-left: 8px;\r\n  background-color: whitesmoke;\r\n}\r\n\r\n.button-section {\r\n  margin: 2px;\r\n  margin-top: 10px;\r\n  height: 30px;\r\n}\r\n\r\nkendo-window {\r\n  border: 1px solid #275cab;\r\n  border-radius: 4px !important;\r\n}\r\n\r\n:host ::ng-deep kendo-window-titlebar,\r\n:host ::ng-deep .k-dialog-titlebar,\r\n:host ::ng-deep .k-window-titlebar {\r\n  background-color: #51738b !important;\r\n  padding: 0.25rem 0.5rem !important;\r\n}\r\n\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 50;\r\n  background: rgba(0, 0, 0, 0.6);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
